<template>
  <div class="history-of-changes-item">
    <div class="history-of-changes-item__container-content">
      <div class="history-of-changes-item__author-event">
        <div
          class="history-of-changes-item__left-indicator"
          :class="{
            'history-of-changes-item__left-indicator--check':
              Number(historyItemDataComputed.ActionType) == ActionEnum.CreateTask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.TransferTask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateType,
            'history-of-changes-item__left-indicator--addobserver':
              Number(historyItemDataComputed.ActionType) == ActionEnum.CreateTask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.AddObserver,
            'history-of-changes-item__left-indicator--removeobserver':
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveObserver ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveFile ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemovePerformer,
            'history-of-changes-item__left-indicator--updatedateend':
              Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDateEnd,
          }"
        >
          <FlagIcon
            v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdatePriority"
            :style="{ color: historyItemDataComputed.Value.ActionColor }"
          ></FlagIcon>
          <CheckIcon
            v-if="
              Number(historyItemDataComputed.ActionType) == ActionEnum.CreateTask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.TransferTask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateType
            "
          ></CheckIcon>
          <EyeIcon
            v-if="
              Number(historyItemDataComputed.ActionType) == ActionEnum.AddObserver ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveObserver
            "
          ></EyeIcon>
          <ClockIcon
            v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDateEnd"
          ></ClockIcon>
          <ConnectIcon
            v-if="
              Number(historyItemDataComputed.ActionType) == ActionEnum.AttachSubtask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveSubtask ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.SetParent ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveParent
            "
          ></ConnectIcon>
          <ChartBarIcon
            v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDifficulty"
            :style="{ color: historyItemDataComputed.Value.ActionColor }"
          ></ChartBarIcon>
          <TirPmIndicator
            size="s"
            v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateStatus"
            :customColor="historyItemDataComputed.Value.ActionColor"
          ></TirPmIndicator>
          <UserCircleIcon
            v-if="
              Number(historyItemDataComputed.ActionType) == ActionEnum.AddPerformer ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemovePerformer
            "
          ></UserCircleIcon>
          <PencilSquareIcon
            v-if="
              Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateName ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDescription
            "
          ></PencilSquareIcon>
          <PaperClipIcon
            v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AttachFile"
          ></PaperClipIcon>
          <TrashIcon
            v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveFile"
          ></TrashIcon>
          <TagIcon
            v-if="
              Number(historyItemDataComputed.ActionType) == ActionEnum.AttachTag ||
              Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveTag
            "
            :style="{ color: historyItemDataComputed.Value.ActionColor }"
          ></TagIcon>
        </div>
        <div class="history-of-changes-item__content">
          <div class="history-of-changes-item__content-title">
            {{ transformNameComputed }}
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.CreateTask">
              cоздал задачу
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.TransferTask">
              перенес(-ла) тикет из другой очереди со статусом:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AddObserver">
              добавил(а) наблюдателей
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveObserver">
              удалил(а) наблюдателей
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDateEnd">
              установил новый дедлайн
              {{ formatedDate }}
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateType">
              поменял(а) тип на "{{ historyItemDataComputed.Value?.Value }}"
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDifficulty">
              поменял(а) сложность на "{{ historyItemDataComputed.Value?.Value }}"
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AttachSubtask">
              добавил(а) подзадачи:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateStatus">
              поменял(а) статус:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AddPerformer">
              добавил(а) исполнителей:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemovePerformer">
              удалил(а) исполнителей:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateName">
              изменил(а) название на: "{{ historyItemDataComputed.Value?.Value }}"
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdatePriority">
              поменял(а) приоритет на: "{{ historyItemDataComputed.Value?.Value }}"
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AttachTag">
              добавил(а) теги:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveTag">
              убрал(а) теги:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateDescription">
              отредактировал(а) описание
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveSubtask">
              убрал(а) подзадачи:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveFile">
              удалил(а) файлы: "{{ historyItemDataComputed.Value?.Value }}"
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AttachFile">
              добавил(а) файлы:
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.SetParent">
              прикрепил(а) родительский тикет
            </span>
            <span v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveParent">
              открепил(а) родительский тикет
            </span>
          </div>
          <div class="history-of-changes-item__additional-slot">
            <TirPmTooltipElement
              width="max-content"
              :position="TirPmTooltipElementPlacementEnum.Right"
            >
              <TirPmIconView
                v-if="
                  Number(historyItemDataComputed.ActionType) == ActionEnum.AddObserver ||
                  Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveObserver ||
                  Number(historyItemDataComputed.ActionType) == ActionEnum.AddPerformer ||
                  Number(historyItemDataComputed.ActionType) == ActionEnum.RemovePerformer
                "
                :colorCode="historyItemDataComputed.Value.ActionColor"
                :imageLoadUrl="historyItemDataComputed.Value.ActionUrl"
                :size="24"
                isBordered
                isRounded
              >
                <template #mainSlot>
                  {{ computedPerformerShortName }}
                </template>
              </TirPmIconView>
              <template #content>
                {{ historyItemDataComputed.Value.AuthorFullName }}
              </template>
            </TirPmTooltipElement>
            <TirPmSelectBadge
              v-if="
                Number(historyItemDataComputed.ActionType) == ActionEnum.AttachSubtask ||
                Number(historyItemDataComputed.ActionType) == ActionEnum.SetParent
              "
            >
              <template #sign>
                {{ historyItemDataComputed.Value?.TaskId }}
              </template>
              <template #iconViewAddon>
                <TirPmIconView
                  :size="24"
                  :isBordered="false"
                  isRounded
                  :colorCode="historyItemDataComputed.Value.ActionColor"
                  :imageLoadUrl="historyItemDataComputed.Value.ActionUrl"
                >
                  <template #mainSlot> </template>
                </TirPmIconView>
              </template>
            </TirPmSelectBadge>
            <TirPmSelectBadge
              v-if="
                Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveSubtask ||
                Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveParent
              "
            >
              <template #sign>
                {{ historyItemDataComputed.Value?.TaskId }}
              </template>
              <template #iconViewAddon>
                <TirPmIconView
                  :size="24"
                  :isBordered="false"
                  isRounded
                  :colorCode="historyItemDataComputed.Value.ActionColor"
                  :imageLoadUrl="historyItemDataComputed.Value.ActionUrl"
                >
                  <template #mainSlot> </template>
                </TirPmIconView>
              </template>
            </TirPmSelectBadge>
            <TirPmStatus
              :label="historyItemDataComputed.Value?.Value"
              is-dotted
              :bg-color="historyItemDataComputed.Value.ActionColor + '20'"
              :label-color="historyItemDataComputed.Value.ActionColor"
              v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.UpdateStatus"
            >
            </TirPmStatus>
            <TirPmStatus
              :label="historyItemDataComputed.Value?.Value"
              is-dotted
              :bg-color="historyItemDataComputed.Value.ActionColor + '20'"
              :label-color="historyItemDataComputed.Value.ActionColor"
              v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.TransferTask"
            >
            </TirPmStatus>
            <TirPmStatus
              :label="historyItemDataComputed.Value?.Value"
              :bg-color="historyItemDataComputed.Value.ActionColor + '20'"
              isBordered
              :label-color="historyItemDataComputed.Value.ActionColor"
              v-if="
                Number(historyItemDataComputed.ActionType) == ActionEnum.AttachTag ||
                Number(historyItemDataComputed.ActionType) == ActionEnum.RemoveTag
              "
            >
            </TirPmStatus>
            <TirPmFilePreview
              v-if="Number(historyItemDataComputed.ActionType) == ActionEnum.AttachFile"
              :file="computedFilePreview"
              hideControls
            ></TirPmFilePreview>
          </div>
        </div>
      </div>
      <div class="history-of-changes-item__user-date">
        <div class="history-of-changes-item__date">
          {{ tirPmDateTransform(historyItemDataComputed.DateCreated).format('DD.MM.YYYY') }}
          в
          {{
            tirPmDateTransform(new Date(historyItemDataComputed.DateCreated + 'Z')).format('HH:mm')
          }}
        </div>
        <TirPmTooltipElement>
          <TirPmIconView
            :size="24"
            :isBordered="false"
            isRounded
            :colorCode="historyItemData.Performer.AvatarColor"
            :imageLoadUrl="historyItemData.Performer.Photo"
          >
            <template #mainSlot>
              {{ historyItemData.Performer.FirstName[0]
              }}{{ historyItemData.Performer.LastName[0] }}
            </template>
          </TirPmIconView>
          <template #content>
            <div class="history-of-changes-item__performer-info">
              {{ historyItemData.Performer.LastName }} {{ historyItemData.Performer.FirstName }}
              {{ historyItemData.Performer.MiddleName }}
            </div>
          </template>
        </TirPmTooltipElement>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { FlagIcon } from 'tir-style-system/icons/solid';
import { TirPmIconView } from 'tir-pm-icon-view';
import { computed, onMounted, PropType } from 'vue';
import { TaskHistoryModel } from './models';
import tirPmDateTransform from 'tir-pm-date-transform';
import utc from 'tir-pm-date-transform/plugin/utc';
import { ActionEnum } from './enums/ActionEnum';
import { TirPmSelectBadge } from 'tir-pm-select-badge';
import { TirPmIndicator } from 'tir-pm-indicator';
import {
  CheckIcon,
  ClockIcon,
  EyeIcon,
  ConnectIcon,
  ChartBarIcon,
  UserCircleIcon,
  PencilSquareIcon,
  PaperClipIcon,
  TagIcon,
  TrashIcon,
} from 'tir-style-system/icons/outline';
import {
  TirPmStatus,
  TirPmStatusBgEnum,
  TirPmStatusTextEnum,
  TirPmTooltipElement,
  TirPmTooltipElementPlacementEnum,
} from 'tir-components';
import { TirPmFilePreview, IFilePreview } from 'tir-pm-file-preview';
import { CurrentUser } from 'tir-pm-user-core';

/**Параметры компонента */
const props = defineProps<{ historyItemData: TaskHistoryModel }>();

/** Данные которые могут измениться */
const historyItemDataComputed = computed(() => {
  return props.historyItemData;
});

/** Трансформировать имя */
const transformNameComputed = computed(() => {
  return `${historyItemDataComputed.value.Performer.FirstName} ${historyItemDataComputed.value.Performer?.LastName[0]}.`;
});
/**Получить часовой пояс */
const correctDate = computed(() => {
  const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])T([01]\d|2[0-3]):[0-5]\d:[0-5]\d(Z)?$/;

  const checkCorrectDate = regex.test(String(historyItemDataComputed.value.Value.Value));
  const value = historyItemDataComputed.value.Value.Value;

  if (checkCorrectDate) {
    if (value.at(-1) !== 'Z') {
      const stringDate = value + 'Z';
      return new Date(stringDate);
    } else {
      return new Date(value);
    }
  } else {
    const timeZone = -new Date(value).getTimezoneOffset() / 60;
    const date = new Date(value);
    date.setHours(date.getHours() + timeZone);
    return date;
  }
});
/**Форматирование времени */
const formatedDate = computed(() => {
  return `${tirPmDateTransform(correctDate.value).format('DD.MM.YYYY')} в ${tirPmDateTransform(
    correctDate.value,
  ).format('HH:mm')}`;
});

// /** Utc смещение */
// const timeOffsetForUtc = (new Date().getTimezoneOffset() / 60) * -1;

const getDateTransform = (date: Date) => {
  let transformedDate = tirPmDateTransform(date).utc(true).utcOffset().format('DD.MM.YYYY HH:mm');
  return {
    date: transformedDate.slice(' ')[0],
    time: transformedDate.slice(' ')[1],
  };
};

/** Трансформировать имя */
const computedPerformerShortName = computed(() => {
  const parts = historyItemDataComputed.value.Value.AuthorFullName.split(' ');
  const firstNameLetter = parts[0]?.[0] || '';
  const lastNameLetter = parts[1]?.[0] || '';
  return `${lastNameLetter}${firstNameLetter}`;
});

const computedFilePreview = computed(() => {
  return {
    FileId: 0,
    Url: historyItemDataComputed.value.Value.ActionUrl,
    Name: historyItemDataComputed.value.Value.ActionUrl,
    Size: 0,
    Accesses: [],
  };
});

// const awdawd = {
//   FileId: 0,
//   Url:
// };

onMounted(() => {
  tirPmDateTransform.extend(utc as any);
});
// historyItemData
</script>

<!-- export default class ActionHistoryValue  {
	ActionValue!: string;
	ActionColor!: string;
	ActionUrl!: string;
	constructor(obj?: Partial<ActionHistoryValue>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
} -->

<style lang="scss">
@import './style.scss';
</style>
